import api from "../index"

const investmentVideos = api.injectEndpoints({
  endpoints: (build) => ({
    createVideo: build.mutation({
      query: (body) => ({
        url: `/investmentVideo/create`,
        method: "POST",
        body,
      }),
    }),
    videosList: build.query({
      query: (params) => ({
        url: `/investmentVideo/list`,
        method: "GET",
        params,
      }),
    }),
    videoDelete: build.mutation({
      query: ({ id }) => ({
        url: `/investmentVideo/${id}`,
        method: "DELETE",
      }),
    }),
    getVideo: build.query({
      query: ({ id }) => ({
        url: `/investmentVideo/${id}`,
        method: "GET",
      }),
    }),
    editVideo: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/investmentVideo/${id}`,
        method: "PUT",
        body: { ...rest },
      }),
    }),
  }),
})

export const {
  useCreateVideoMutation,
  useEditVideoMutation,
  useLazyGetVideoQuery,
  useLazyVideosListQuery,
  useVideoDeleteMutation,
} = investmentVideos
